import { resource, Resource, Service, signal } from '@angular/core';

@Service()
export class CookieManager {
  async get(key: string): Promise<CookieListItem | null> {
    return cookieStore.get(key);
  }

  async set(options: CookieInit): Promise<void> {
    await cookieStore.set(options);
  }

  async remove(options: CookieStoreDeleteOptions): Promise<void> {
    await cookieStore.delete(options);
  }

  observe(name: string): Resource<CookieListItem | null> {
    return resource({
      stream: async ({ abortSignal }) => {
        const cookie = await cookieStore.get(name);
        const result = signal({ value: cookie });

        cookieStore.addEventListener(
          'change',
          (event) => {
            const changedCookie = event.changed.find((cookie) => name === cookie.name);
            if (changedCookie) {
              result.set({ value: changedCookie });
            }
            const removedCookie = event.deleted.find((cookie) => name === cookie.name);
            if (removedCookie) {
              result.set({ value: null });
            }
          },
          { signal: abortSignal },
        );
        return result;
      },
      defaultValue: null,
    }).asReadonly();
  }
}
